import { OptionsProps } from "../../components";
import { SelectOption } from "../../types";
import { translate } from "../../intl";
import { TranslateFnType } from "../../intl/translate";

export enum OptionsEnum {
  YES = "YES",
  NO = "NO",
  UNKNOWN = "UNKNOWN",
  NOT_APPLICABLE = "NOT_APPLICABLE",
  ON_GOING = "ON_GOING",
}

export const getOptionsYesOrNo = (): OptionsProps[] => [
  { label: translate("formGeneric.yes"), value: OptionsEnum.YES },
  { label: translate("formGeneric.no"), value: OptionsEnum.NO },
];

export const getOptionsYesOrNoV2 = (): OptionsProps[] => [
  { label: translate("formGeneric.yes"), value: true },
  { label: translate("formGeneric.no"), value: false },
];

export const getOptionsYesOrNotRequired = (): OptionsProps[] => [
  { label: translate("formGeneric.yes"), value: true },
  { label: translate("ctoStep1.notRequired"), value: false },
];

export const getOptionsYesNoOrUnknown = (): OptionsProps[] => [
  ...getOptionsYesOrNoV2(),
  { label: translate("formGeneric.unknownLabel"), value: OptionsEnum.UNKNOWN },
];

export const getOptionsWithNotApplicable = (): OptionsProps[] => [
  ...getOptionsYesOrNoV2(),
  {
    label: translate("formGeneric.notApplication"),
    value: OptionsEnum.NOT_APPLICABLE,
  },
];

export const getOptionsAcceptOrReject = (): OptionsProps[] => [
  { label: translate("formGeneric.accept"), value: OptionsEnum.YES },
  { label: translate("formGeneric.reject"), value: OptionsEnum.NO },
];

export const getLabel = (
  options: OptionsProps[],
  value: string | boolean,
): string => {
  return (
    options.find((option) => {
      const optionValue = option.value ?? option.label;
      return optionValue === value;
    })?.label ?? "-"
  );
};

export const getOptionAll = (translate: TranslateFnType): SelectOption[] => [
  {
    id: translate("formGeneric.all"),
    label: translate("formGeneric.all"),
  },
];

export const validateEmail = (email?: string) =>
  email ? /\S+@\S+\.\S+/.test(email) : false;

export const focusElement = (element: HTMLElement | null) => {
  if (!element) return;

  let targetElement: HTMLElement | null = element;

  if (
    element instanceof HTMLInputElement &&
    (element.type === "radio" || element.type === "file")
  ) {
    targetElement?.focus({ preventScroll: true });

    targetElement =
      targetElement.closest("fieldset, div, .radio-group") ?? targetElement;
  } else {
    targetElement.focus({ preventScroll: true });
  }

  setTimeout(
    () =>
      targetElement?.scrollIntoView({ block: "center", behavior: "smooth" }),
    125,
  );
};
